import { api } from './authenticatedApi';

export type Stance = 'required' | 'preferred' | 'neutral' | 'prohibited';

export interface FleetPolicy {
  id: string;
  entitySlug: string;
  entityName: string;
  stance: Stance;
  satisfiedBy: string[];
  note: string | null;
}

export class PolicyService {
  static async list(orgId: string) {
    return api.get<{ policies: FleetPolicy[] }>(`/orgs/${orgId}/policies`);
  }

  static async upsert(
    orgId: string,
    data: {
      entitySlug: string;
      entityName: string;
      stance: Stance;
      satisfiedBy?: string[];
      note?: string;
    },
  ) {
    return api.put<FleetPolicy>(`/orgs/${orgId}/policies`, data);
  }

  static async remove(orgId: string, entitySlug: string) {
    return api.delete(`/orgs/${orgId}/policies/${encodeURIComponent(entitySlug)}`);
  }

  static async compliance(orgId: string) {
    return api.get<PolicyCompliance>(`/orgs/${orgId}/policy-compliance`);
  }
}

export interface PolicyViolation {
  entitySlug: string;
  entityName: string;
  kind: 'prohibited_in_use' | 'required_missing';
  note: string | null;
}

export interface PolicyCompliance {
  summary: { policyCount: number; reposInViolation: number; totalViolations: number };
  byPolicy: { entitySlug: string; entityName: string; stance: string; violatedBy: number }[];
  repos: { id: string; name: string; violations: PolicyViolation[] }[];
}
